module.exports = __webpack_public_path__ + "img/logo-colorful.79a32539.png";